import { ProductDoc, ProductStateCode } from '@gooduncles/gu-app-schema';
import { FC } from 'react';

import FlexSpacer from 'src/components/atoms/FlexSpacer';
import ImageWithFallback from 'src/components/atoms/Image/ImageWithFallback';

import classes from './ProductThumbnail.module.scss';

const invalidState = [ProductStateCode.DISCONTINUED, ProductStateCode.OUTOFSTOCK];

interface ProductThumbnailProps {
  product: ProductDoc;
  onClick?: () => void;
  overlayTop?: JSX.Element;
  overlayBottom?: JSX.Element;
  border?: boolean;
}

const ProductThumbnail: FC<ProductThumbnailProps> = ({
  product,
  onClick,
  overlayTop,
  overlayBottom,
  border = true,
}) => {
  return (
    <div className={classes.productThumbnail} onClick={onClick}>
      <ImageWithFallback src={product.thumbnail ?? undefined} alt={product.fullName} />
      <div className={`${classes.overlayBox} ${border ? classes.overlayBorder : ''}`}>
        <div className={classes.top}>
          {product.imageDescription ? (
            <div className={classes.imageDescription}>{product.imageDescription}</div>
          ) : (
            <FlexSpacer />
          )}
          {overlayTop}
        </div>
        <div className={classes.bottom}>{overlayBottom}</div>
      </div>
      {invalidState.includes(product.state) && (
        <div className={classes.invalid}>
          <span>{product.state === ProductStateCode.OUTOFSTOCK ? '품절' : '판매중지'}</span>
        </div>
      )}
    </div>
  );
};

export default ProductThumbnail;
